import { AsyncSystemTask } from '@app/models/common/async-system-tasks.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';

export class StatusColumn extends BadgeColumn<AsyncSystemTask> {
    title = 'Status';
    property = null;
    type: CellDisplay = CellDisplay.badge;

    getBadgeDisplay(asyncSystemTask: AsyncSystemTask): BadgeDisplay | undefined {
        if (asyncSystemTask.isComplete()) {
            return {
                type: 'success',
                label: 'Completed',
            };
        }

        if (asyncSystemTask.isFailed()) {
            return {
                type: 'danger',
                label: 'Failed',
            };
        }

        return {
            type: 'default',
            label: 'Running',
        };
    }
}
